import { gsap } from "gsap"
import * as THREE from "three"
import {
  debugObject,
  deviceStateManager,
  loaders,
  scene,
  tShirtFolder,
} from "./Experience"

export class GarmentTShirt {
  constructor() {
    this.tShirtVideoGraphic = document.querySelector("#video")
    this.setTShirt()
  }

  setTShirt() {
    loaders.gltfLoader.load("/assets/models/TShirt-Animated6.gltf", (gltf) => {
      this.tShirtGroup = gltf.scene

      this.tShirtGroup.position.set(0.2, -1.25, 0)
      this.tShirtGroup.rotation.y = -0.82

      // setInterval(() => {
      //   console.log(this.tShirtGroup.rotation)
      // }, 5000)

      //Animation
      this.mixer = new THREE.AnimationMixer(this.tShirtGroup)
      this.tonearmAction = this.mixer.clipAction(gltf.animations[0])
      this.discAction = this.mixer.clipAction(gltf.animations[1])

      //Mask TurnTable and ring around graphic
      this.tShirtGroup.traverse((child) => {
        if (child.isMesh) {
          // console.log(child)
          if (
            child.name == "TurnTableBase" ||
            child.name === "TurnTableLights" ||
            child.name === "ToneArm" ||
            child.name === "Disc" ||
            child.name === "GraphicCircle" ||
            child.name === "Tag"
          ) {
            child.material.stencilWrite = true
            child.material.stencilRef = 1
            child.material.stencilFunc = THREE.EqualStencilFunc
            child.renderOrder = 4
          }
        }
      })

      // Mask t-shirt
      this.tShirt = this.tShirtGroup.getObjectByName("TShirt")
      this.tShirt.material.stencilWrite = true
      this.tShirt.material.stencilFunc = THREE.NotEqualStencilFunc
      this.tShirt.material.stencilRef = 2
      this.tShirt.renderOrder = 4

      this.tShirtStencil = this.tShirtGroup.getObjectByName("TShirtStencil")

      this.tShirtStencil.material = new THREE.MeshBasicMaterial({
        color: 0xff00ff,
        side: THREE.FrontSide,
        colorWrite: false,
        depthWrite: false,
        stencilWrite: true,
        stencilFunc: THREE.GreaterEqualStencilFunc,
        stencilRef: 1,
        stencilZPass: THREE.IncrementWrapStencilOp,
      })
      this.tShirtStencil.renderOrder = 2

      this.tShirtGraphic = this.tShirtGroup.getObjectByName("TShirtGraphic")
      this.tShirtGraphic.material.blending = THREE.AdditiveBlending
      this.tShirtGraphic.material.stencilWrite = true
      this.tShirtGraphic.material.stencilFunc = THREE.EqualStencilFunc
      this.tShirtGraphic.material.stencilRef = 2
      this.tShirtGraphic.renderOrder = 4

      //Video Texture
      const videoTexture = new THREE.VideoTexture(this.tShirtVideoGraphic)
      videoTexture.flipY = false
      videoTexture.encoding = THREE.sRGBEncoding

      //Sync turn table animations with t-shirt animation
      setTimeout(() => {
        // this.tonearmAction.timeScale = 0.83
        // this.discAction.timeScale = 0.83

        this.tonearmAction.timeScale = 0.852
        this.discAction.timeScale = 0.852

        this.tShirtVideoGraphic.play()
        this.tonearmAction.play()
        this.discAction.play()
      }, 2000)

      this.tShirtGraphic.material.map = videoTexture

      scene.add(this.tShirtGroup)

      this.setTShirtAnimations()

      this.setTweaks()
    })
  }

  setTShirtAnimations() {
    this.tl = gsap.timeline()

    // this.tl.to(this.tShirtGroup.rotation, {
    //   x: 0.2,
    //   y: 0,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-1",
    //     scrub: 0.5,
    //     start: "top bottom",
    //     end: "center center",
    //     markers: true,
    //   },
    // })
    // this.tl.to(this.tShirtGroup.position, {
    //   y: 0.08,
    //   z: 0.6,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-1",
    //     scrub: 0.5,
    //     start: "top bottom",
    //     end: "center center",
    //     markers: true,
    //   },
    // })
  }

  setTweaks() {
    tShirtFolder
      .addInput(debugObject, "turnTableSpeeds", {
        min: 0.5,
        max: 2,
        step: 0.001,
        label: "Turn Table Speed",
      })
      .on("change", (ev) => {
        this.tonearmAction.timeScale = ev.value
        this.discAction.timeScale = ev.value
      })

    tShirtFolder.addInput(this.tShirtGroup.rotation, "y", {
      min: -Math.PI * 2,
      max: Math.PI * 2,
      step: 0.01,
      label: "T-Shirt rotation Y",
    })
  }
}
